<template>
  <PageView :main-title="$t('404-page-not-found')" no-sub-title-expected="true">
    <ContentView>
      {{ $t("404-page-not-found-details") }}
    </ContentView>
  </PageView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import PageView from "@/views/commons/PageView.vue"
import ContentView from "@/views/commons/ContentView.vue"

export default defineComponent({
  name: "NotFound404Page",
  components: { PageView, ContentView },
})
</script>
